import * as React from "react";
const WhiteCheckMarkSvg = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.535 6.668a6.667 6.667 0 1 1-3.2-4.444"
      stroke="#fff"
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6 7.335 2 2 6.667-6.667"
      stroke="#fff"
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default WhiteCheckMarkSvg;
